import i18n, { i18n_t } from '@/locales/i18n';
import ConstantConfig from '@/renderer/scripts/utils/ConstantConfig';
type Validator = {
  validator: {};
  rules: {};
};
export default function orgNameValidator(name: string): Validator {
  const validator = {
    orgName(name: string) {
      return new Promise(resolve => {
        const timer = setTimeout(() => {
          resolve(name.length <= ConstantConfig.orgNameMaxLength);
          clearTimeout(timer);
        });
      });
    },
  };
  const rules = {
    orgName: [
      {
        required: true,
        message: i18n_t('企业名称必填'),
        type: 'error',
        trigger: 'change',
      },
      {
        validator: validator.orgName,
        message: i18n_t('企业名称字数超出限制'),
      },
    ],
  };
  return {
    validator,
    rules,
  };
}
